import React from 'react';
import parse from 'html-react-parser';

// Same as home Hero overlay so bg image is visible in the back ($primaryDark / $bodyBg)
const HERO_STYLE_OVERLAY = 'linear-gradient(135deg, rgba(3, 16, 30, 0.92) 0%, rgba(10, 15, 26, 0.85) 100%)';

export default function BannerSectionStyle5({
  bgUrl,
  imgUrl,
  title,
  subTitle,
}) {
  return (
    <>
      <style>
        {`
          .cs_banner_style_5_highlighted {
            color: #ffffff;
            font-weight: 700;
            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
          }
          .cs_banner_style_5_subtitle_highlighted {
            color: #ffffff;
            font-weight: 600;
            text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
          }
        `}
      </style>
      <section
        className="cs_banner cs_style_5 cs_bg_filed"
        style={{ 
          backgroundImage: bgUrl ? `${HERO_STYLE_OVERLAY}, url(${bgUrl})` : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
        }}
      >
        <div className="cs_banner_img">
          <img src={imgUrl} alt="Banner" style={{ 
            maxHeight: '400px',
            width: 'auto',
            objectFit: 'contain'
          }} />
        </div>
        <div className="container">
          <div className="cs_banner_text">
            <h2 className="cs_banner_title cs_fs_72 cs_banner_style_5_highlighted" style={{
              fontSize: '72px',
              lineHeight: '1.2',
              marginBottom: '20px'
            }}>
              {parse(title)}
            </h2>
            <p className="cs_banner_subtitle cs_fs_20 mb-0 cs_banner_style_5_subtitle_highlighted" style={{
              fontSize: '20px',
              lineHeight: '1.5'
            }}>
              {parse(subTitle)}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
